import { Injectable } from "@angular/core";
import { DeliveryOption } from './DeliveryOption';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';

@Injectable({
    providedIn: 'root'
})
export class DeliveryOptionService {

    constructor(public firestore: AngularFirestore) {
    }

    public updateDeliveryOption(deliveryOption: DeliveryOption, id: any) {
        return this.getCollection().doc(id).update(deliveryOption)
    }

    public deleteDeliveryOption(deliveryOptionId: string) {
        return this.getCollection().doc(deliveryOptionId).delete().then(() => { return true });
    }

    public getCollection(): AngularFirestoreCollection {
        const collection = this.firestore.collection(`deliveryOptions`);
        return collection;
    }

    public addDeliveryOption(deliveryOption: DeliveryOption): Promise<DocumentReference> {
        return this.getCollection().add(deliveryOption);
    }
}